<table
	mat-table
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th mat-header-cell *matHeaderCellDef class="text-center">
			<em>No shifts yet</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="rwic">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>RWIC</th>
		<td mat-cell *matCellDef="let shift">
			<ng-container *ngIf="!isRwicNull(shift); else rwicNull">
				{{ shift.rwic?.name }}
			</ng-container>
			<ng-template #rwicNull>
				<div class="rwic-not-assigned">
					Not Assigned
				</div>
			</ng-template>
		</td>
	</ng-container>

	<ng-container matColumnDef="day">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Day</th>
		<td mat-cell *matCellDef="let shift">
			{{ shift.day | date: 'EEEE, MMM d, yyyy':'utc' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="startTime">
		<th mat-header-cell *matHeaderCellDef>Start Time</th>
		<td mat-cell *matCellDef="let shift">
			{{ getStartTime(shift) }}
		</td>
	</ng-container>

	<ng-container matColumnDef="serviceType">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Service Type</th>
		<td mat-cell *matCellDef="let shift">
			{{ displayDescription(shift.serviceType) }}
		</td>
	</ng-container>

	<ng-container matColumnDef="deleteShift">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let shift">
			<button
				mat-icon-button
				rpsharedConfirm="Delete shift on {{
					shift.day | date: 'shortDate':'utc'
				}}?"
				(onConfirmed)="deleteShift(shift)"
				color="warn"
				matTooltip="Delete Shift"
			>
				<mat-icon>delete</mat-icon>
			</button>
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="dataSource.length < 1"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="dataSource.length > 0"
	></tr>
	<tr
		mat-row
		*matRowDef="let shift; columns: resultColumns"
		[@animateList]
	></tr>
</table>

<br />
<div fxLayout="row">
	<div>
		<mat-paginator [length]="resultCount"> </mat-paginator>
	</div>

	<span class="spacer"></span>
	<div class="pr-5" fxLayoutAlign="center center">
		<button
			mat-mini-fab
			color="warn"
			(click)="deleteShifts()"
			class="mr-2 remove-button"
			matTooltip="Delete Multiple Shifts"
		>
			<mat-icon aria-label="Shifts delete button">remove</mat-icon>
		</button>
		<button
			mat-mini-fab
			color="primary"
			(click)="addShifts()"
			class="mr-2"
			matTooltip="Add Multiple Shifts"
		>
			<mat-icon aria-label="Shifts add button">playlist_add</mat-icon>
		</button>
		<button
			mat-mini-fab
			color="primary"
			(click)="addShift()"
			matTooltip="Add Shift"
		>
			<mat-icon aria-label="Shift add button">add</mat-icon>
		</button>
	</div>
</div>
